/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import type { ValidatorMap } from "ember-changeset/types";
import type { IntlService } from "ember-intl";
import JournalEventBasedComponent from "parog-web/components/forc/abstract/journal-event-based-component";
import journalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import TherapeuticAssistanceSessionCompletedJournalEvent from "parog-web/models/therapeutic-assistance-session-completed-journal-event";

export default class TherapeuticAssistanceEditionFormComponent extends JournalEventBasedComponent {
  static fullComponentId = "therapeutic-assistance/edition-form";
  static forcDisplayName = "Séance d'accompagnement thérapeutique";

  @service declare intl: IntlService;

  get validations(): ValidatorMap {
    return this.journalEventClass.validations(this.intl);
  }

  static journalEventClass = TherapeuticAssistanceSessionCompletedJournalEvent;

  retrieveJournalEvent = journalEventRetrievalStrategies.sourceJournalEvent;

  journalEventProperties = [
    "occurredAt",
    "situation",
    "name",
    "diagnostic",
    "educationSubjects",
    "patientQuestions",
    "wrapUp",
    "comments"
  ];

  retrieveModel(): Record<string, unknown> {
    const model = super.retrieveModel();
    if (this.isNewMode) {
      model.occurredAt = new Date();
    }

    return model;
  }
}
